<template>
  <div class="min-h-screen bg-gray-100 flex items-center justify-center">
    <div class="bg-white shadow-lg rounded-lg p-8 max-w-md w-full">
      <h1 class="text-2xl font-bold text-center">Pinyin Converter</h1>
      <p class="text-sm font-semibold text-center mb-6">Proudly offered by <a target="_blank" href="https://issacchan.com" >Issac</a></p>
      <p v-if="error" class="text-red-500 text-center mt-4">{{ error }}</p>
      <div v-if="pinyinResult.withTones" class="flex flex-col mt-4 rounded-lg  bg-slate-100 p-4 items-center mb-2">
        <h2 class="text-lg font-semibold">Results</h2>
        <p>{{ pinyinResult.withoutTones }}</p>
      </div>
      <form @submit.prevent="convertToPinyin" class="space-y-4">
        <textarea
          v-model="inputText"
          class="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          rows="4"
          placeholder="Enter Chinese characters here..."
          required
        ></textarea>
        <button
          type="submit"
          class="w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600 transition"
        >
          {{ loading ? "Converting..." : "Convert to Pinyin" }}
        </button>
      </form>
      
    </div>
  </div>
</template>

<script>
import pinyinUtil from "pinyin-util";

export default {
  data() {
    return {
      inputText: "", // User input for Chinese characters
      pinyinResult: {
        withTones: "", // Pinyin result with tones
        withoutTones: "", // Pinyin result without tones
      },
      loading: false, // Loading state for the button
      error: "", // Error message if any issue occurs
    };
  },
  methods: {
    convertToPinyin() {
      this.loading = true; // Show loading state
      this.error = ""; // Reset error message

      try {
        if (!this.inputText.trim()) {
          this.error = "Please enter some Chinese characters.";
          this.loading = false;
          return;
        }

        // Convert input text to Pinyin using pinyin-util
        this.pinyinResult.withTones = pinyinUtil.getPinyin(this.inputText, " ", true);
        this.pinyinResult.withoutTones = pinyinUtil.getPinyin(this.inputText, " ", false);
      } catch (err) {
        this.error = "An error occurred while converting to Pinyin.";
      } finally {
        this.loading = false; // Reset loading state
      }
    },
  },
};
</script>

<style scoped>
/* Add any custom styles here if needed */
</style>
